import React from 'react';
import { css } from '@emotion/core';
import MuiDialog from '@material-ui/core/Dialog';
import ShowEffect from 'client/components/Result/prizeList/ShowEffect';
import ScrollerFixedHeader from 'client/components/Result/prizeList/ScrollerFixedHeader';
import { useFixedPopupHeightResizePostMessage } from 'client/hooks/useHeightResizePostMessage';

export const modes = {
    COMP: 'component',
    GLOBAL: 'global'
};

export default function PopupWithFixHeader({
    maxWidth = 720,
    mode = modes.COMP,
    title,
    styles,
    show = false,
    onEffectEntered,
    onEffectExited,
    onClose,
    children,
    customDialogStyle
}) {
    const bindRef = useFixedPopupHeightResizePostMessage({ isTrigger: show });

    return mode === modes.COMP ? (
        show && (
            <ShowEffect show={show} onEntered={onEffectEntered} onExited={onEffectExited}>
                <div
                    id="promo-prize-list"
                    css={[baseStyle, compPopupStyle, css(`max-width: ${maxWidth}px;`, styles)]}
                >
                    <ScrollerFixedHeader title={title} onClose={onClose} />
                    <div css={listContainerStyle} ref={bindRef}>
                        {children}
                    </div>
                </div>
            </ShowEffect>
        )
    ) : (
        <MuiDialog
            disableAutoFocus
            disableEnforceFocus
            disableRestoreFocus
            fullWidth
            open={show}
            css={[muiDialogStyle, customDialogStyle]}
        >
            <div css={[baseStyle, dialogStyle, css(`max-width: ${maxWidth}px;`, styles)]}>
                <ScrollerFixedHeader title={title} onClose={onClose} />
                <div css={listContainerStyle}>{children}</div>
            </div>
        </MuiDialog>
    );
}

const baseStyle = css`
    background: #fff;
    border-radius: 8px;
    overflow: auto;
`;

const compPopupStyle = css`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    min-height: 100%;
    height: 100%;
    z-index: 5;
`;

const dialogStyle = css`
    width: calc(100%);
    height: auto;
    max-height: calc(100% - 120px);
    min-height: 240px;
`;

const listContainerStyle = css`
    padding: 0 16px 8px;
`;

const muiDialogStyle = css`
    .MuiDialog-paper {
        width: calc(100% - 32px);
        max-height: calc(100% - 32px);
        margin: 16px;
        border-radius: 24px;
    }
`;
